import React from 'react';
import s from './AnimatedLogo.module.scss';
import { motion } from 'framer-motion';

const AnimatedLogo = ({ width = 50, height = 50, stroke = '#FFFFFF' }) => {
    return (
        <div className={s.Root}>
            <svg
                width={width}
                height={height}
                viewBox="0 0 88 104"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                {/* BOX NO ANIMATION */}
                <path
                    d="M5 29.0021L43.802 6.0376L83 29.0021V31.3777V76.1188L44 98.1794L43.802 98.2914L5 76.1188V31.3777V29.0021Z"
                    stroke={stroke}
                    strokeWidth={9.50254}
                />

                {/* LEFT LINE */}
                <motion.path
                    style={{
                        stroke: stroke,
                        strokeWidth: 9.50254,
                        fill: 'transparent',
                    }}
                    animate={{
                        d: [
                            'M5 31.3774L43.802 31.3774',
                            'M5 30.9082L43.802 52.6849',
                            'M5 30.9082L43.802 52.6849',
                            'M5 30.9082L43.802 52.6849',
                            'M5 31.3774L43.802 31.3774',
                            'M5 31.3774L43.802 31.3774',
                            'M5 31.3774L43.802 31.3774',
                        ],
                    }}
                    transition={{
                        repeat: Infinity,
                        ease: 'easeInOut',
                        duration: 3,
                    }}
                />

                {/* RIGHT LINE */}
                <motion.path
                    style={{
                        stroke: stroke,
                        strokeWidth: 9.50254,
                        fill: 'transparent',
                    }}
                    animate={{
                        d: [
                            'M43.8008 31.3774L82.6028 31.3774',
                            'M43.8008 52.6846L82.6028 30.9079',
                            'M43.8008 52.6846L82.6028 30.9079',
                            'M43.8008 52.6846L82.6028 30.9079',
                            'M43.8008 31.3774L82.6028 31.3774',
                            'M43.8008 31.3774L82.6028 31.3774',
                            'M43.8008 31.3774L82.6028 31.3774',
                        ],
                    }}
                    transition={{
                        repeat: Infinity,
                        ease: 'easeInOut',
                        duration: 3,
                    }}
                />

                {/* VERTICAL LINE */}
                <motion.path
                    style={{
                        stroke: stroke,
                        strokeWidth: 9.50254,
                        fill: 'transparent',
                    }}
                    animate={{
                        d: [
                            'M43.8008 31.3774L43.8008 64.6363L43.8008 97.8952',
                            'M43.8008 50.3091L43.8008 73.6695L43.8008 97.0299',
                            'M43.8008 50.3091L43.8008 73.6695L43.8008 97.0299',
                            'M43.8008 50.3091L43.8008 73.6695L43.8008 97.0299',
                            'M43.8008 31.3774L43.8008 64.6363L43.8008 97.8952',
                            'M43.8008 31.3774L43.8008 64.6363L43.8008 97.8952',
                            'M43.8008 31.3774L43.8008 64.6363L43.8008 97.8952',
                        ],
                    }}
                    transition={{
                        repeat: Infinity,
                        ease: 'easeInOut',
                        duration: 3,
                    }}
                />
            </svg>
        </div>
    );
};
export default AnimatedLogo;
